import React from 'react'
import { FormatValueDecimal } from '../../utils/Validate'

const ViewOrderCharges = ({ viewItem, percentageValue, currencyDetail }) => {

    return (
        <>
            <div className="card-header">
                <h1>Order Charges</h1>
            </div>
            <div className="card-body">
                <div className="table-responsive order-charges-table">
                    <table className="table table-borderless">
                        <tbody>
                            <tr>
                                <td>
                                    <p>Total list price</p>
                                    <h6>{FormatValueDecimal(viewItem?.totalListPrice)}</h6>
                                </td>
                                <td>
                                    <p>Net price</p>
                                    <h6>{FormatValueDecimal(viewItem?.netPrice)}</h6>
                                </td>
                                <td>
                                    <p>Special charges</p>
                                    <h6>{FormatValueDecimal(viewItem?.specialCharges)}</h6>
                                </td>
                                <td>
                                    <p>SDR</p>
                                    <h6>{FormatValueDecimal(viewItem?.sdrCharges)}</h6>
                                </td>
                                <td>
                                    <p>Total Selling Price</p>
                                    <h6>{FormatValueDecimal(viewItem?.totalSellingPrice)}</h6>
                                </td>
                                <td>
                                    <p>Special discounts</p>
                                    <h6>{viewItem?.discountPercentage || 0} %</h6>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Tax</p>
                                    <h6>{viewItem?.taxPercentage || 0} %</h6>
                                </td>
                                <td>
                                    <p>Average Sales Margin</p>
                                    <h6>{viewItem?.salesMarginPercentage || 0} %</h6>
                                </td>
                                <td>
                                    <p>Freight & delivery charges</p>
                                    <h6>{FormatValueDecimal(viewItem?.freightCharges)}</h6>
                                </td>
                                <td>
                                    <p>Custom duty</p>
                                    <h6>{FormatValueDecimal(percentageValue?.customDuty)}</h6>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default ViewOrderCharges